import React, { useEffect, useState, useMemo } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { useAuth } from "../../AuthContext";
import { Dialog } from "primereact/dialog";
import { ProgressSpinner } from "primereact/progressspinner";
import { InputMask } from "primereact/inputmask";
import { Checkbox } from "primereact/checkbox";
import { MultiSelect } from "primereact/multiselect";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";

import "primeicons/primeicons.css";

import {
  FaBuilding,
  FaIdCard,
  FaCheckCircle,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaMapPin,
  FaCity,
  FaGlobeAmericas,
  FaSearch,
  FaListAlt,
  FaCreditCard,
  FaMailBulk,
} from "react-icons/fa";

const Empresas = () => {
  const { user } = useAuth();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [empresas, setEmpresas] = useState([]);
  const [visibleNovaEmpresa, setVisibleNovaEmpresa] = useState(false);
  const [visibleEditarEmpresa, setVisibleEditarEmpresa] = useState(false);
  const [visibleFormasPagamento, setVisibleFormasPagamento] = useState(false);
  const [visualizacaoResumida, setVisualizacaoResumida] = useState(false);

  const [empresaPagamentoEditandoId, setEmpresaPagamentoEditandoId] =
    useState(null);

  // Estado para as formas de pagamento (useState)
  const [formasPagamentoSelecionadas, setFormasPagamentoSelecionadas] =
    useState([]);

  // Lista fixa de formas de pagamento disponíveis
  const formasPagamentoDisponiveis = [
    { id: 1, descricao: "Cartão de Crédito" },
    { id: 2, descricao: "Cartão de Débito" },
    { id: 3, descricao: "Carteira" },
    { id: 4, descricao: "Dinheiro" },
    { id: 5, descricao: "Pix" },
    { id: 6, descricao: "Outros" },
    { id: 7, descricao: "Saldo" },
  ];

  //Cadastro
  const [empresaEditandoId, setEmpresaEditandoId] = useState(null);
  const [nome, setNome] = useState("");
  const [cnpj, setCnpj] = useState("");
  const [email, setEmail] = useState("");
  const [telefone, setTelefone] = useState("");
  const [logradouro, setLogradouro] = useState("");
  const [numero, setNumero] = useState("");
  const [bairro, setBairro] = useState("");
  const [cidade, setCidade] = useState("");
  const [estado, setEstado] = useState("");
  const [cep, setCep] = useState("");
  const [ativo, setAtivo] = useState(true);

  // Estados para os dialogs de confirmação
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");

  //Filtro
  const [mostrarFiltroEmpresa, setMostrarFiltroEmpresa] = useState(false);
  const [filtroNome, setFiltroNome] = useState("");
  const [filtroCnpj, setFiltroCnpj] = useState("");
  const [filtroCidade, setFiltroCidade] = useState("");

  useEffect(() => {
    fetchEmpresas();
  }, []);

  // Empresas filtrados e ordenados
  const empresasFiltrados = useMemo(() => {
    return empresas.filter((empresa) => {
      // Verifica filtro de nome (se filtroNome não estiver vazio)
      const nomeMatch =
        !filtroNome ||
        empresa.nome.toLowerCase().includes(filtroNome.toLowerCase());

      // Verifica filtro de CNPJ (se filtroCnpj não estiver vazio)
      const cnpjMatch =
        !filtroCnpj ||
        empresa.cnpj.toLowerCase().includes(filtroCnpj.toLowerCase());

      // Verifica filtro de cidade (se filtroCidade não estiver vazio)
      const cidadeMatch =
        !filtroCidade ||
        empresa.cidade.toLowerCase().includes(filtroCidade.toLowerCase());

      // Retorna true apenas se TODOS os filtros ativos corresponderem
      return nomeMatch && cnpjMatch && cidadeMatch;
    });
  }, [empresas, filtroNome, filtroCnpj, filtroCidade]);

  const fetchEmpresas = async () => {
    setLoading(true);
    setError(null);

    try {
      if (!user?.token) {
        throw new Error("Usuário não autenticado. Faça login novamente.");
      }

      const response = await fetch(
        "https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/empresas",
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${user.token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          credentials: "include",
        },
      );

      if (!response.ok) {
        throw new Error("Erro ao buscar empresas");
      }

      const data = await response.json();

      console.log("Empresas = ", data.data);

      if (data.success && Array.isArray(data.data)) {
        setEmpresas(data.data);
        setError(null);
      } else {
        setEmpresas([]);
        setError("Nenhuma empresa encontrada.");
      }
    } catch (error) {
      setError(error.message);
      setEmpresas([]);
    } finally {
      setLoading(false);
    }
  };

  const resetarCampos = () => {
    setNome("");
    setCnpj("");
    setEmail("");
    setTelefone("");
    setLogradouro("");
    setNumero("");
    setBairro("");
    setCidade("");
    setEstado("");
    setCep("");
    setAtivo(true);

    setFiltroNome("");
    setFiltroCnpj("");
    setFiltroCidade("");
  };

  // Validar formulário de adicionar
  const validarFormulario = () => {
    return (
      nome.trim() &&
      cnpj &&
      email &&
      telefone &&
      logradouro &&
      numero &&
      bairro &&
      cidade
    );
  };

  const handleSalvar = async () => {
    setLoading(true);
    setError(null);

    try {
      if (!user?.token) {
        throw new Error("Usuário não autenticado. Faça login novamente.");
      }

      // Verificação dos campos obrigatórios
      if (!nome || !cnpj || !telefone || !email) {
        alert("Preencha todos os campos obrigatórios");
        return;
      }

      const empresaData = {
        nome: nome,
        cnpj: cnpj,
        telefone: telefone,
        email: email,
        logradouro: logradouro,
        numero: numero,
        bairro: bairro,
        cidade: cidade,
        estado: estado,
        cep: cep,
        ativo: "1",
      };

      const response = await fetch(
        "https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/empresas",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
            Accept: "application/json",
          },
          body: JSON.stringify(empresaData),
        },
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || "Falha ao cadastrar empresa");
      }

      await response.json();
      setDialogMessage("Empresa cadastrada com sucesso!");
      setShowSuccessDialog(true);
      fetchEmpresas();
      setVisibleNovaEmpresa(false);
      resetarCampos();
    } catch (err) {
      console.error("Erro detalhado ao salvar:", err);
      setDialogMessage(err.message || "Erro ao cadastrar empresa");
      setShowErrorDialog(true);
    } finally {
      setLoading(false);
    }
  };

  const handleEditar = async (empresaId) => {
    setLoading(true);
    setError(null);

    try {
      if (!user?.token) {
        throw new Error("Usuário não autenticado. Faça login novamente.");
      }

      if (!nome || !cnpj || !telefone || !email) {
        setDialogMessage("Preencha todos os campos obrigatórios");
        setShowErrorDialog(true);
        return;
      }

      const empresaData = {
        nome: nome,
        cnpj: cnpj,
        telefone: telefone,
        email: email,
        logradouro: logradouro,
        numero: numero,
        bairro: bairro,
        cidade: cidade,
        estado: estado,
        cep: cep,
        ativo: ativo ? "1" : "0",
      };

      const response = await fetch(
        `https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/empresas/${empresaId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
            Accept: "application/json",
          },
          body: JSON.stringify(empresaData),
        },
      );

      const responseData = await response.json();

      if (!response.ok) {
        const errorMessage =
          responseData?.message ||
          responseData?.data?.message ||
          `Erro HTTP ${response.status}`;
        throw new Error(errorMessage);
      }

      setDialogMessage("Empresa atualizada com sucesso!");
      setShowSuccessDialog(true);
      fetchEmpresas();
      setVisibleEditarEmpresa(false);
      resetarCampos();
    } catch (err) {
      console.error("Erro na edição:", err);
      setDialogMessage(
        err.message.includes("não encontrada")
          ? "Empresa não encontrada ou já removida"
          : err.message,
      );
      setShowErrorDialog(true);
    } finally {
      setLoading(false);
    }
  };

  //----------------------------------------------------------------------
  //--------------------------- Forma de Pagamento -----------------------
  //----------------------------------------------------------------------
  const handleAdicionarFormaPagamento = (forma) => {
    setFormasPagamentoSelecionadas([...formasPagamentoSelecionadas, forma]);
  };

  const handleRemoverFormaPagamento = (formaId) => {
    setFormasPagamentoSelecionadas(
      formasPagamentoSelecionadas.filter((f) => f.id !== formaId),
    );
  };

  const handleSalvarFormasPagamento = async () => {
    setLoading(true);
    setError(null);

    try {
      if (!user?.token) {
        throw new Error("Usuário não autenticado.");
      }

      if (!empresaPagamentoEditandoId) {
        throw new Error("ID da empresa não definido.");
      }

      // Preparar os dados no formato que seu backend espera
      // IMPORTANTE: Para novas seleções, NÃO enviar o ID
      const formasValidas = formasPagamentoSelecionadas.map((f) => ({
        // Se a forma veio do banco (tem ID numérico), mantém o ID
        // Se é uma nova seleção (veio da lista fixa), NÃO envia o ID
        ...(f.id && f.id <= 99 ? {} : { id: f.id }), // Não envia ID para formas da lista fixa
        descricao: f.descricao,
      }));

      console.log("Enviando dados:", {
        formas_pagamento: formasValidas,
      });

      const response = await fetch(
        `https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/empresas/${empresaPagamentoEditandoId}/formas-pagamento`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
            Accept: "application/json",
          },
          body: JSON.stringify({
            formas_pagamento: formasValidas,
          }),
        },
      );

      const result = await response.json();

      console.log("Resposta do servidor:", result);

      if (response.ok && result?.success) {
        // Buscar novamente para atualizar os dados
        await buscarFormasPagamentoEmpresa(empresaPagamentoEditandoId);

        setDialogMessage(
          formasPagamentoSelecionadas.length === 0
            ? "Todas as formas de pagamento foram removidas!"
            : "Formas de pagamento salvas com sucesso!",
        );
        setShowSuccessDialog(true);
        setVisibleFormasPagamento(false);
      } else {
        throw new Error(
          result?.message || "Erro ao salvar formas de pagamento",
        );
      }
    } catch (error) {
      console.error("Erro ao salvar formas de pagamento:", error);
      setDialogMessage(
        "Erro ao salvar formas de pagamento: " + (error.message || error),
      );
      setShowErrorDialog(true);
    } finally {
      setLoading(false);
    }
  };

  // Buscar formas existentes (mantive sua função com pequenas melhorias)
  const buscarFormasPagamentoEmpresa = async (empresaId) => {
    try {
      const response = await fetch(
        `https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/empresas/${empresaId}/formas-pagamento`,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
            Accept: "application/json",
          },
        },
      );

      if (response.ok) {
        const result = await response.json();
        // O backend retorna os dados em result.data
        const formasExistente = result.data || [];

        // Mapear as formas existentes para o formato do MultiSelect
        const formasMapeadas = formasExistente.map((forma) => ({
          id: forma.id,
          descricao: forma.descricao,
        }));

        setFormasPagamentoSelecionadas(formasMapeadas);

        console.log("Formas carregadas:", formasMapeadas);
      }
    } catch (error) {
      console.error("Erro ao buscar formas de pagamento:", error);
    }
  };
  // ----------------- Fim Formas de Pagamento -----------------

  {
    /* Return Principal */
  }
  return (
    <div
      style={{
        fontFamily: "'Rajdhani', sans-serif",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
      }}
    >
      {/* Dialog de Sucesso */}
      <Dialog
        visible={showSuccessDialog}
        style={{ width: "350px", fontFamily: "'Rajdhani', sans-serif" }}
        onHide={() => setShowSuccessDialog(false)}
        draggable={false}
        closable={false}
        header={null}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "20px",
            padding: "10px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "25px",
              height: "25px",
              borderRadius: "50%",
              color: "#22C55E",
              fontSize: "2.2rem",
            }}
          >
            <i
              className="pi pi-check-circle"
              style={{ fontSize: "2.5rem" }}
            ></i>
          </div>
          <p
            style={{
              textAlign: "center",
              fontSize: "1rem",
              margin: 0,
              color: "#374151",
            }}
          >
            {dialogMessage}
          </p>
          <Button
            label="OK"
            icon="pi pi-check"
            onClick={() => setShowSuccessDialog(false)}
            className="p-button-success"
            style={{
              padding: "6px 20px",
              fontWeight: "bold",
              fontSize: "0.9rem",
            }}
          />
        </div>
      </Dialog>

      {/* Dialog de Erro */}
      <Dialog
        visible={showErrorDialog}
        style={{ width: "350px", fontFamily: "'Rajdhani', sans-serif" }}
        onHide={() => setShowErrorDialog(false)}
        draggable={false}
        closable={false}
        header={null}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "20px",
            padding: "10px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "25px",
              height: "25px",
              borderRadius: "50%",
              color: "#EF4444",
              fontSize: "2.2rem",
            }}
          >
            <i
              className="pi pi-times-circle"
              style={{ fontSize: "2.5rem" }}
            ></i>
          </div>
          <p
            style={{
              textAlign: "center",
              fontSize: "1rem",
              margin: 0,
              color: "#374151",
            }}
          >
            {dialogMessage}
          </p>
          <Button
            label="OK"
            onClick={() => setShowErrorDialog(false)}
            className="p-button-danger"
            style={{
              padding: "6px 20px",
              fontWeight: "bold",
              fontSize: "0.9rem",
            }}
          />
        </div>
      </Dialog>

      {/* Dialog Novo */}
      <Dialog
        visible={visibleNovaEmpresa}
        style={{
          width: "90vw",
          maxWidth: "768px",
          fontFamily: "'Rajdhani', sans-serif",
        }}
        onHide={() => {
          if (!loading) {
            resetarCampos();
            setVisibleNovaEmpresa(false);
          }
        }}
        draggable={false}
        header={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "-25px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div style={{ marginRight: "8px", paddingLeft: "8px" }}>
                <FaBuilding style={{ fontSize: "2.4rem", color: "#B83732" }} />
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <div
                  style={{
                    fontSize: "0.9rem",
                    width: "100%",
                    letterSpacing: "1px",
                  }}
                >
                  ADICIONAR
                </div>
                <div
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    marginTop: "-10px",
                  }}
                >
                  EMPRESA
                </div>
              </div>
            </div>
          </div>
        }
      >
        <>
          {/* Formulário em Cards */}
          <div style={{ padding: "10px 0" }}>
            {/* 1ª Linha - Nome e CNPJ */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                gap: "5px",
                marginBottom: "5px",
              }}
            >
              {/* Card Nome */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #3498DB",
                    }}
                  >
                    <FaBuilding
                      style={{ color: "#3498DB", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Nome *
                    </span>
                  </div>
                  <InputText
                    placeholder="Nome da empresa"
                    value={nome}
                    onChange={(e) => setNome(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
              {/* Card CNPJ */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #E67E22",
                    }}
                  >
                    <FaIdCard
                      style={{ color: "#E67E22", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      CNPJ *
                    </span>
                  </div>
                  <InputMask
                    placeholder="00.000.000/0000-00"
                    value={cnpj}
                    onChange={(e) => setCnpj(e.target.value)}
                    mask="99.999.999/9999-99"
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
            </div>

            {/* 2ª Linha - Email e Telefone */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                gap: "5px",
                marginBottom: "5px",
              }}
            >
              {/* Card Telefone */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #2980B9",
                    }}
                  >
                    <FaPhone style={{ color: "#2980B9", fontSize: "0.9rem" }} />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Telefone *
                    </span>
                  </div>
                  <InputMask
                    placeholder="(00) 0000-0000"
                    value={telefone}
                    mask="(99) 9999-9999"
                    onChange={(e) => setTelefone(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
              {/* Card Email */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #D35400",
                    }}
                  >
                    <FaEnvelope
                      style={{ color: "#D35400", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Email *
                    </span>
                  </div>
                  <InputText
                    placeholder="email@empresa.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
            </div>

            {/* 3 linha - Endereço, Número e Bairro */}
            <div className="grid-endereco-numero-bairro">
              {/* Card Endereço */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #16A085",
                    }}
                  >
                    <FaMapMarkerAlt
                      style={{ color: "#16A085", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Endereço
                    </span>
                  </div>
                  <InputText
                    placeholder="Rua, Avenida, etc."
                    value={logradouro}
                    onChange={(e) => setLogradouro(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
              {/* Card Número */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #8E44AD",
                    }}
                  >
                    <FaMapPin
                      style={{ color: "#8E44AD", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Número
                    </span>
                  </div>
                  <InputText
                    placeholder="Número"
                    value={numero}
                    onChange={(e) => setNumero(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
              {/* Card Bairro */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #F1C40F",
                    }}
                  >
                    <FaMapMarkerAlt
                      style={{ color: "#F1C40F", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Bairro
                    </span>
                  </div>
                  <InputText
                    placeholder="Bairro"
                    value={bairro}
                    onChange={(e) => setBairro(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
            </div>

            {/* 4 Linha - Cidade, Estado, CEP e Ativo */}
            <div className="grid-endereco-numero-bairro-ativo">
              {/* Card Cidade */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #27AE60",
                    }}
                  >
                    <FaCity style={{ color: "#27AE60", fontSize: "0.9rem" }} />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Cidade
                    </span>
                  </div>
                  <InputText
                    placeholder="Cidade"
                    value={cidade}
                    onChange={(e) => setCidade(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
              {/* Card Estado */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #E74C3C",
                    }}
                  >
                    <FaGlobeAmericas
                      style={{ color: "#E74C3C", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Estado
                    </span>
                  </div>
                  <InputText
                    placeholder="Estado"
                    value={estado}
                    onChange={(e) => setEstado(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
              {/* Card CEP */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #95A5A6",
                    }}
                  >
                    <FaMailBulk
                      style={{ color: "#95A5A6", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      CEP
                    </span>
                  </div>
                  <InputMask
                    placeholder="00.000-000"
                    value={cep}
                    onChange={(e) => setCep(e.target.value)}
                    mask="99.999-999"
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
              {/* Card Ativo */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #2980B9",
                    }}
                  >
                    <FaCheckCircle
                      style={{ color: "#2980B9", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Ativo *
                    </span>
                  </div>
                  <Checkbox
                    checked={ativo}
                    onChange={(e) => setAtivo(e.checked)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Botão Fechar */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "15px",
              flexWrap: "wrap",
            }}
          >
            <Button
              label="CANCELAR"
              icon="pi pi-times"
              onClick={() => {
                resetarCampos();
                setVisibleNovaEmpresa(false);
              }}
              className="p-button-outlined p-button-sm"
              style={{
                outline: "none",
                boxShadow: "none",
                padding: "8px 24px",
                minWidth: "120px",
                borderColor: "#dee2e6",
                color: "#495057",
                fontWeight: "500",
                fontSize: "0.875rem",
              }}
              disabled={loading}
            />
            <Button
              label={loading ? "SALVANDO..." : "CADASTRAR EMPRESA"}
              icon="pi pi-check"
              onClick={handleSalvar}
              className="p-button-success p-button-sm"
              style={{
                outline: "none",
                boxShadow: "none",
                padding: "8px 24px",
                minWidth: "160px",
                fontWeight: "500",
                fontSize: "0.875rem",
              }}
              disabled={loading || !validarFormulario()}
              loading={loading}
            />
          </div>
        </>
      </Dialog>

      {/* Dialog Editar */}
      <Dialog
        visible={visibleEditarEmpresa}
        style={{
          width: "90vw",
          maxWidth: "768px",
          fontFamily: "'Rajdhani', sans-serif",
        }}
        onHide={() => {
          if (!loading) {
            resetarCampos();
            setVisibleEditarEmpresa(false);
          }
        }}
        draggable={false}
        header={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "-25px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div style={{ marginRight: "8px", paddingLeft: "8px" }}>
                <FaBuilding style={{ fontSize: "2.4rem", color: "#B83732" }} />
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <div
                  style={{
                    fontSize: "0.9rem",
                    width: "100%",
                    letterSpacing: "1px",
                  }}
                >
                  EDITAR
                </div>
                <div
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    marginTop: "-10px",
                  }}
                >
                  EMPRESA
                </div>
              </div>
            </div>
          </div>
        }
      >
        <>
          {/* Formulário em Cards */}
          <div style={{ padding: "10px 0" }}>
            {/* 1ª Linha - Nome e CNPJ */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                gap: "5px",
                marginBottom: "5px",
              }}
            >
              {/* Card Nome */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #3498DB",
                    }}
                  >
                    <FaBuilding
                      style={{ color: "#3498DB", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Nome *
                    </span>
                  </div>
                  <InputText
                    placeholder="Nome da empresa"
                    value={nome}
                    onChange={(e) => setNome(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
              {/* Card CNPJ */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #E67E22",
                    }}
                  >
                    <FaIdCard
                      style={{ color: "#E67E22", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      CNPJ *
                    </span>
                  </div>
                  <InputMask
                    placeholder="00.000.000/0000-00"
                    value={cnpj}
                    onChange={(e) => setCnpj(e.target.value)}
                    mask="99.999.999/9999-99"
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
            </div>

            {/* 2ª Linha - Email e Telefone */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                gap: "5px",
                marginBottom: "5px",
              }}
            >
              {/* Card Telefone */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #2980B9",
                    }}
                  >
                    <FaPhone style={{ color: "#2980B9", fontSize: "0.9rem" }} />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Telefone *
                    </span>
                  </div>
                  <InputMask
                    placeholder="(00) 0000-0000"
                    value={telefone}
                    mask="(99) 9999-9999"
                    onChange={(e) => setTelefone(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
              {/* Card Email */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #D35400",
                    }}
                  >
                    <FaEnvelope
                      style={{ color: "#D35400", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Email *
                    </span>
                  </div>
                  <InputText
                    placeholder="email@empresa.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
            </div>

            {/* 3 linha - Endereço, Número e Bairro */}
            <div className="grid-endereco-numero-bairro">
              {/* Card Endereço */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #16A085",
                    }}
                  >
                    <FaMapMarkerAlt
                      style={{ color: "#16A085", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Endereço
                    </span>
                  </div>
                  <InputText
                    placeholder="Rua, Avenida, etc."
                    value={logradouro}
                    onChange={(e) => setLogradouro(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
              {/* Card Número */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #8E44AD",
                    }}
                  >
                    <FaMapPin
                      style={{ color: "#8E44AD", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Número
                    </span>
                  </div>
                  <InputText
                    placeholder="Número"
                    value={numero}
                    onChange={(e) => setNumero(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
              {/* Card Bairro */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #F1C40F",
                    }}
                  >
                    <FaMapMarkerAlt
                      style={{ color: "#F1C40F", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Bairro
                    </span>
                  </div>
                  <InputText
                    placeholder="Bairro"
                    value={bairro}
                    onChange={(e) => setBairro(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
            </div>

            {/* 4 Linha - Cidade, Estado, CEP e Ativo */}
            <div className="grid-endereco-numero-bairro-ativo">
              {/* Card Cidade */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #27AE60",
                    }}
                  >
                    <FaCity style={{ color: "#27AE60", fontSize: "0.9rem" }} />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Cidade
                    </span>
                  </div>
                  <InputText
                    placeholder="Cidade"
                    value={cidade}
                    onChange={(e) => setCidade(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
              {/* Card Estado */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #E74C3C",
                    }}
                  >
                    <FaGlobeAmericas
                      style={{ color: "#E74C3C", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Estado
                    </span>
                  </div>
                  <InputText
                    placeholder="Estado"
                    value={estado}
                    onChange={(e) => setEstado(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
              {/* Card CEP */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #95A5A6",
                    }}
                  >
                    <FaMailBulk
                      style={{ color: "#95A5A6", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      CEP
                    </span>
                  </div>
                  <InputMask
                    placeholder="00.000-000"
                    value={cep}
                    onChange={(e) => setCep(e.target.value)}
                    mask="99.999-999"
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
              {/* Card Ativo */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #2980B9",
                    }}
                  >
                    <FaCheckCircle
                      style={{ color: "#2980B9", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Ativo *
                    </span>
                  </div>
                  <Checkbox
                    checked={ativo}
                    onChange={(e) => setAtivo(e.checked)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Botão Fechar */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "15px",
              flexWrap: "wrap",
            }}
          >
            <Button
              label="CANCELAR"
              icon="pi pi-times"
              onClick={() => {
                resetarCampos();
                setVisibleEditarEmpresa(false);
              }}
              className="p-button-outlined p-button-sm"
              style={{
                outline: "none",
                boxShadow: "none",
                padding: "8px 24px",
                minWidth: "120px",
                borderColor: "#dee2e6",
                color: "#495057",
                fontWeight: "500",
                fontSize: "0.875rem",
              }}
              disabled={loading}
            />
            <Button
              label={loading ? "SALVANDO..." : "SALVAR ALTERAÇÕES"}
              icon="pi pi-check"
              onClick={() => handleEditar(empresaEditandoId)}
              className="p-button-success p-button-sm"
              style={{
                outline: "none",
                boxShadow: "none",
                padding: "8px 24px",
                minWidth: "160px",
                fontWeight: "500",
                fontSize: "0.875rem",
              }}
              disabled={loading || !validarFormulario()}
              loading={loading}
            />
          </div>
        </>
      </Dialog>

      {/* Dialog Formas de Pagamento */}
      <Dialog
        visible={visibleFormasPagamento}
        style={{
          width: "90vw",
          maxWidth: "768px",
          fontFamily: "'Rajdhani', sans-serif",
        }}
        onHide={() => !loading && setVisibleFormasPagamento(false)}
        draggable={false}
        header={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "-25px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div style={{ marginRight: "8px", paddingLeft: "8px" }}>
                <FaCreditCard
                  style={{ fontSize: "2.4rem", color: "#B83732" }}
                />
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <div
                  style={{
                    fontSize: "0.9rem",
                    width: "100%",
                    letterSpacing: "1px",
                  }}
                >
                  FORMAS DE
                </div>
                <div
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    marginTop: "-10px",
                  }}
                >
                  PAGAMENTO
                </div>
              </div>
            </div>
          </div>
        }
      >
        {/* Formulário em Cards */}
        <div style={{ padding: "10px 0" }}>
          {/* Card Principal - Lista de Formas de Pagamento */}
          <div
            style={{
              display: "grid",
              backgroundColor: "#fafafa",
              border: "1px solid #e8e8e8",
              padding: "15px",
              borderRadius: "6px",
              gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
              gap: "5px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                width: "100%",
              }}
            >
              {/* Cabeçalho do Card */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingBottom: "10px",
                  borderBottom: "2px solid #3498DB",
                }}
              >
                {/* Título do Card */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <FaCreditCard
                    style={{ color: "#3498DB", fontSize: "1rem" }}
                  />
                  <span
                    style={{
                      fontWeight: "600",
                      color: "#2c3e50",
                      fontSize: "1rem",
                      letterSpacing: "0.3px",
                    }}
                  >
                    Formas de Pagamento
                  </span>
                </div>
              </div>

              {/* Seletor de Formas de Pagamento - MULTISELECT */}
              <div
                style={{
                  backgroundColor: "#fff",
                  border: "1px solid #e8e8e8",
                  borderRadius: "6px",
                  padding: "10px",
                }}
              >
                <MultiSelect
                  value={formasPagamentoSelecionadas}
                  options={formasPagamentoDisponiveis.filter(
                    (f) =>
                      !formasPagamentoSelecionadas.some(
                        (selected) => selected.id === f.id,
                      ),
                  )}
                  optionLabel="descricao"
                  placeholder="Selecione as formas de pagamento..."
                  style={{
                    outline: "none",
                    boxShadow: "none",
                    width: "100%",
                    fontFamily: "'Rajdhani', sans-serif",
                    border: "1px solid #dee2e6",
                    borderRadius: "4px",
                  }}
                  panelStyle={{
                    fontFamily: "'Rajdhani', sans-serif",
                  }}
                  onChange={(e) => setFormasPagamentoSelecionadas(e.value)}
                  itemTemplate={(f) => (
                    <div
                      style={{
                        fontFamily: "'Rajdhani', sans-serif",
                        padding: "8px 12px",
                        fontSize: "0.9rem",
                      }}
                    >
                      <div style={{ fontWeight: "600", color: "#2c3e50" }}>
                        {f.descricao}
                      </div>
                    </div>
                  )}
                  emptyMessage="Nenhuma forma de pagamento disponível"
                />
              </div>

              {/* Área das Formas de Pagamento Selecionadas */}
              <div style={{ marginBottom: "10px" }}>
                {formasPagamentoSelecionadas.length > 0 ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    {formasPagamentoSelecionadas.map((forma, index) => (
                      <div
                        key={forma.id}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          padding: "10px",
                          backgroundColor: "white",
                          borderRadius: "6px",
                          border: "1px solid #e8e8e8",
                          transition: "all 0.2s ease",
                        }}
                      >
                        {/* Número de Ordem */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "24px",
                            height: "24px",
                            backgroundColor: "#3498DB",
                            color: "white",
                            borderRadius: "50%",
                            fontSize: "0.8rem",
                            fontWeight: "600",
                            flexShrink: 0,
                          }}
                        >
                          {index + 1}
                        </div>

                        {/* Informações da Forma de Pagamento */}
                        <div
                          style={{
                            flex: 1,
                            padding: "8px 12px",
                            backgroundColor: "white",
                            border: "1px solid #dee2e6",
                            borderRadius: "4px",
                            outline: "none",
                            fontSize: "0.9rem",
                            fontWeight: "500",
                            color: "#2c3e50",
                            fontFamily: "'Rajdhani', sans-serif",
                          }}
                        >
                          <div style={{ fontWeight: "600" }}>
                            {forma.descricao}
                          </div>
                        </div>

                        {/* Botão Remover */}
                        <Button
                          icon="pi pi-trash"
                          onClick={() => handleRemoverFormaPagamento(forma.id)}
                          className="p-button-danger p-button-sm"
                          style={{
                            width: "34px",
                            height: "34px",
                            flexShrink: 0,
                          }}
                          tooltip="Remover"
                          tooltipOptions={{ position: "top" }}
                        />
                      </div>
                    ))}
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "5px",
                      backgroundColor: "#fafafa",
                      border: "2px dashed #dee2e6",
                      borderRadius: "6px",
                      textAlign: "center",
                    }}
                  >
                    <FaCreditCard
                      style={{
                        fontSize: "2.5rem",
                        color: "#adb5bd",
                        opacity: 0.5,
                      }}
                    />
                    <h4
                      style={{
                        fontSize: "1rem",
                        color: "#6c757d",
                        marginBottom: "8px",
                        fontWeight: "600",
                      }}
                    >
                      Nenhuma forma de pagamento selecionada
                    </h4>
                    <p
                      style={{
                        fontSize: "0.85rem",
                        color: "#adb5bd",
                        margin: 0,
                        lineHeight: "1.4",
                      }}
                    >
                      Selecione as formas de pagamento na lista acima
                    </p>
                  </div>
                )}
              </div>

              {/* Resumo */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingTop: "5px",
                  borderTop: "1px solid #e8e8e8",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    fontSize: "0.85rem",
                    color: "#7f8c8d",
                  }}
                >
                  <FaListAlt style={{ fontSize: "0.9rem" }} />
                  <span>
                    {formasPagamentoSelecionadas.length} forma(s) de pagamento
                    selecionada(s)
                  </span>
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    alignItems: "center",
                  }}
                >
                  {formasPagamentoSelecionadas.length > 0 && (
                    <div
                      style={{
                        fontSize: "0.75rem",
                        color: "#28a745",
                        backgroundColor: "#e8f5e9",
                        padding: "3px 10px",
                        borderRadius: "12px",
                        fontWeight: "600",
                      }}
                    >
                      {formasPagamentoSelecionadas.length} formas
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Botões */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "15px",
            marginTop: "5px",
            flexWrap: "wrap",
          }}
        >
          <Button
            label="CANCELAR"
            icon="pi pi-times"
            onClick={() => {
              setFormasPagamentoSelecionadas([]);
              setVisibleFormasPagamento(false);
            }}
            className="p-button-outlined p-button-sm"
            style={{
              outline: "none",
              boxShadow: "none",
              padding: "6px 20px",
              minWidth: "100px",
              borderColor: "#dee2e6",
              color: "#495057",
              fontWeight: "500",
              fontSize: "0.875rem",
            }}
            disabled={loading}
          />
          <Button
            label={loading ? "SALVANDO..." : "SALVAR ALTERAÇÕES"}
            icon="pi pi-check"
            onClick={handleSalvarFormasPagamento}
            className="p-button-success p-button-sm"
            style={{
              outline: "none",
              boxShadow: "none",
              padding: "8px 24px",
              minWidth: "150px",
              fontWeight: "500",
              fontSize: "0.875rem",
            }}
            disabled={loading}
            loading={loading}
          />
        </div>
      </Dialog>

      {/* Barra superior vermelha */}
      <div
        style={{
          backgroundColor: "#B83732",
          height: "40px",
          minHeight: "40px",
          width: "100%",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 20px",
          fontWeight: "bold",
          position: "fixed",
          zIndex: 1,
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        {/* lado esquerdo */}
        <div></div>

        {/* Centro */}
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Button
            icon="pi pi-refresh"
            className="icon-button-titulo"
            onClick={() => {
              fetchEmpresas();
              resetarCampos();
            }}
            style={{
              border: "none",
              outline: "none",
              boxShadow: "none",
              color: "#ffffff",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            outlined
          />
          <Button
            icon={visualizacaoResumida ? "pi pi-eye" : "pi pi-eye-slash"}
            className="icon-button-titulo"
            onClick={() => {
              setVisualizacaoResumida(!visualizacaoResumida);
            }}
            style={{
              border: "none",
              outline: "none",
              boxShadow: "none",
              color: "#ffffff",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            outlined
          />
          <Button
            icon={mostrarFiltroEmpresa ? "pi pi-filter-slash" : "pi pi-filter"}
            className="icon-button-titulo"
            onClick={() => {
              setMostrarFiltroEmpresa(!mostrarFiltroEmpresa);
            }}
            style={{
              border: "none",
              outline: "none",
              boxShadow: "none",
              color: "#ffffff",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            outlined
          />
          <Button
            icon="pi pi-plus"
            className="icon-button-titulo"
            onClick={() => {
              if (
                user.tipo === "administrator" ||
                user.modulos?.Empresas?.editar
              ) {
                setVisibleNovaEmpresa(true);
                resetarCampos();
              }
            }}
            disabled={
              !(user.tipo === "administrator" || user.modulos?.Empresas?.editar)
            }
            style={{
              border: "none",
              outline: "none",
              boxShadow: "none",
              color: "#ffffff",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
              opacity:
                user.tipo === "administrator" || user.modulos?.Empresas?.editar
                  ? 1
                  : 0.4,
              cursor:
                user.tipo === "administrator" || user.modulos?.Empresas?.editar
                  ? "pointer"
                  : "not-allowed",
            }}
            outlined
          />
        </div>

        {/* lado direito */}
        <div></div>
      </div>

      {/* Conteúdo abaixo da barra */}
      <div style={{ flex: 1, padding: "50px 10px" }}>
        {/* MOSTRAR RESERVAS DO DIA SELECIONADO - SEMPRE VISÍVEL */}
        <div style={{ borderRadius: "8px", padding: "0 15px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              borderBottom: "1px solid #E2E8F0",
            }}
          >
            <div style={{ marginTop: "7px" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "8px",
                  gap: "5px",
                }}
              >
                <FaBuilding style={{ color: "#B83732", fontSize: "1.2rem" }} />
                <h3 style={{ margin: 0, color: "#424242" }}>EMPRESAS</h3>

                {/* Bolinha com quantidade */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minWidth: "25px",
                    height: "25px",
                    background:
                      "linear-gradient(135deg, #B83732 0%, #D65A55 100%)",
                    borderRadius: "50px",
                    padding: "0 8px",
                    margin: "0 8px",
                    boxShadow: "0 2px 4px rgba(184, 55, 50, 0.2)",
                  }}
                >
                  <span
                    style={{
                      color: "white",
                      fontSize: "0.85rem",
                      fontWeight: "600",
                      lineHeight: 1,
                    }}
                  >
                    {empresas.length}
                  </span>
                </div>
              </div>
            </div>

            <div>
              <IconField iconPosition="left">
                <InputIcon className="pi pi-search"> </InputIcon>
                <InputText
                  className="p-inputtext-sm"
                  placeholder="Pesquisar por Nome"
                  value={filtroNome}
                  onChange={(e) => setFiltroNome(e.target.value)}
                  style={{
                    outline: "none",
                    boxShadow: "none",
                    width: "100%",
                    height: "30px",
                    fontFamily: "'Rajdhani', sans-serif",
                  }}
                />
              </IconField>
            </div>
          </div>

          {/* InputSwitch */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
              marginBottom: "30px",
            }}
          ></div>

          {/* Filtros*/}
          {mostrarFiltroEmpresa && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  borderRadius: "8px",
                  padding: "10px 8px",
                  border: "1px solid #dee2e6",
                  backgroundColor: "#fff",
                  width: "95%",
                  maxWidth: "720px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                }}
              >
                {/* 1ª Linha - Nome e CPF */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "repeat(auto-fill, minmax(200px, 1fr))",
                    gap: "10px",
                  }}
                >
                  {/* Card Nome */}
                  <div style={{ padding: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          paddingBottom: "5px",
                          borderBottom: "2px solid #3498DB",
                        }}
                      >
                        <FaBuilding
                          style={{ color: "#3498DB", fontSize: "0.9rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.95rem",
                            letterSpacing: "0.3px",
                          }}
                        >
                          Nome{" "}
                        </span>
                      </div>
                      <InputText
                        className="p-inputtext-sm"
                        placeholder="Nome da empresa"
                        value={filtroNome}
                        onChange={(e) => setFiltroNome(e.target.value)}
                        style={{
                          outline: "none",
                          boxShadow: "none",
                          width: "100%",
                          height: "35px",
                          fontFamily: "'Rajdhani', sans-serif",
                        }}
                      />
                    </div>
                  </div>

                  {/* Card CNPJ */}
                  <div style={{ padding: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          paddingBottom: "5px",
                          borderBottom: "2px solid #E67E22",
                        }}
                      >
                        <FaIdCard
                          style={{ color: "#E67E22", fontSize: "0.9rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.95rem",
                            letterSpacing: "0.3px",
                          }}
                        >
                          CNPJ{" "}
                        </span>
                      </div>
                      <InputText
                        className="p-inputtext-sm"
                        placeholder="CNPJ da empresa"
                        value={filtroCnpj}
                        onChange={(e) => setFiltroCnpj(e.target.value)}
                        style={{
                          outline: "none",
                          boxShadow: "none",
                          width: "100%",
                          height: "35px",
                          fontFamily: "'Rajdhani', sans-serif",
                        }}
                      />
                    </div>
                  </div>

                  {/* Card Cidade */}
                  <div style={{ padding: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          paddingBottom: "5px",
                          borderBottom: "2px solid #27ae60",
                        }}
                      >
                        <FaCity
                          style={{ color: "#27ae60", fontSize: "0.9rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.95rem",
                            letterSpacing: "0.3px",
                          }}
                        >
                          Cidade
                        </span>
                      </div>
                      <InputText
                        className="p-inputtext-sm"
                        placeholder="Cidade da empresa"
                        value={filtroCidade}
                        onChange={(e) => setFiltroCidade(e.target.value)}
                        style={{
                          outline: "none",
                          boxShadow: "none",
                          width: "100%",
                          height: "35px",
                          fontFamily: "'Rajdhani', sans-serif",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Grids */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "10px 8px",
            }}
          >
            {empresasFiltrados.length === 0 ? (
              <div
                style={{
                  textAlign: "center",
                  padding: "40px 20px",
                  backgroundColor: "#f5f5f5",
                  borderRadius: "8px",
                  border: "2px dashed #e8e8e8",
                }}
              >
                <FaBuilding
                  style={{
                    fontSize: "3rem",
                    color: "#B83732",
                    marginBottom: "15px",
                    opacity: 0.5,
                  }}
                />
                <h3
                  style={{
                    color: "#2c3e50",
                    margin: "0 0 10px 0",
                    fontSize: "1.2rem",
                    fontWeight: "600",
                  }}
                >
                  Nenhuma empresa encontrada
                </h3>
              </div>
            ) : !visualizacaoResumida ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                {empresasFiltrados.map((item, idx) => (
                  <div key={idx}>
                    <div
                      style={{
                        backgroundColor: "#ffffff",
                        border: "1px solid #e8e8e8",
                        borderRadius: "10px",
                        padding: "12px 14px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "12px",
                        flexWrap: "wrap",
                      }}
                    >
                      {/* Bloco esquerdo - Empresa */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          minWidth: "260px",
                          flex: "1 1 260px",
                        }}
                      >
                        <div
                          style={{
                            background:
                              "linear-gradient(135deg, #B83732 0%, #D65A55 100%)",
                            borderRadius: "10px",
                            padding: "10px",
                            display: "inline-flex",
                          }}
                        >
                          <FaBuilding
                            style={{ fontSize: "1.5rem", color: "#fff" }}
                          />
                        </div>
                        <div style={{ minWidth: 0 }}>
                          <h3
                            style={{
                              fontSize: "1rem",
                              fontWeight: "600",
                              color: "#2c3e50",
                              margin: 0,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.nome}
                          </h3>

                          {/* Info Tags */}
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "5px",
                              alignItems: "center",
                              color: "#64748b",
                              fontSize: "0.9rem",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                                marginRight: "6px",
                              }}
                            >
                              <FaIdCard
                                style={{ fontSize: "0.7rem", color: "#64748b" }}
                              />
                              <span>{item.cnpj}</span>
                            </div>

                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                                marginRight: "6px",
                              }}
                            >
                              <FaPhone
                                style={{ fontSize: "0.7rem", color: "#2980b9" }}
                              />
                              <span>{item.telefone}</span>
                            </div>

                            {item.cidade && (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                }}
                              >
                                <FaMapMarkerAlt
                                  style={{
                                    fontSize: "0.7rem",
                                    color: "#e74c3c",
                                  }}
                                />
                                <span>
                                  {[item.cidade, item.estado]
                                    .filter(Boolean)
                                    .join(" - ")}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Status + Ações */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-end",
                          gap: "8px",
                          flex: "1 1 320px",
                          marginLeft: "auto",
                          flexWrap: "wrap",
                        }}
                      >
                        <div
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "6px",
                            padding: "2px 6px",
                            borderRadius: "12px",
                            fontSize: "0.75rem",
                            fontWeight: "500",
                            color: item.ativo === "1" ? "#27ae60" : "#e74c3c",
                          }}
                        >
                          <div
                            style={{
                              width: "12px",
                              height: "12px",
                              borderRadius: "50%",
                              backgroundColor:
                                item.ativo === "1" ? "#27ae60" : "#e74c3c",
                            }}
                          />
                        </div>

                        {/* Botões de ação */}
                        <Button
                          icon="pi pi-file-edit"
                          onClick={() => {
                            if (
                              user.tipo === "administrator" ||
                              user.modulos?.Empresas?.editar
                            ) {
                              setEmpresaEditandoId(item.id);

                              // Preenche os campos do formulário
                              setNome(item.nome || "");
                              setCnpj(item.cnpj || "");
                              setEmail(item.email || "");
                              setTelefone(item.telefone || "");
                              setLogradouro(item.logradouro || "");
                              setNumero(item.numero || "");
                              setBairro(item.bairro || "");
                              setCidade(item.cidade || "");
                              setEstado(item.estado || "");
                              setCep(item.cep || "");
                              setAtivo(item.ativo === "1");
                              setVisibleEditarEmpresa(true);
                            }
                          }}
                          disabled={
                            !(
                              user.tipo === "administrator" ||
                              user.modulos?.Empresas?.editar
                            )
                          }
                          className="p-button-outlined p-button-sm"
                          style={{
                            outline: "none",
                            boxShadow: "none",
                            width: "25px",
                            height: "25px",
                            borderColor: "#dee2e6",
                            color: "#495057",
                            opacity:
                              user.tipo === "administrator" ||
                              user.modulos?.Empresas?.editar
                                ? 1
                                : 0.4,
                            cursor:
                              user.tipo === "administrator" ||
                              user.modulos?.Empresas?.editar
                                ? "pointer"
                                : "not-allowed",
                          }}
                          tooltip="Editar"
                          tooltipOptions={{ position: "top" }}
                        />

                        <Button
                          icon="pi pi-credit-card"
                          onClick={async () => {
                            if (
                              user.tipo === "administrator" ||
                              user.modulos?.Empresas?.editar
                            ) {
                              setEmpresaPagamentoEditandoId(item.id);
                              await buscarFormasPagamentoEmpresa(item.id);
                              setVisibleFormasPagamento(true);
                            }
                          }}
                          disabled={
                            !(
                              user.tipo === "administrator" ||
                              user.modulos?.Empresas?.editar
                            )
                          }
                          className="p-button-outlined p-button-sm"
                          style={{
                            outline: "none",
                            boxShadow: "none",
                            width: "25px",
                            height: "25px",
                            borderColor: "#dee2e6",
                            color: "#495057",
                            opacity:
                              user.tipo === "administrator" ||
                              user.modulos?.Empresas?.editar
                                ? 1
                                : 0.4,
                            cursor:
                              user.tipo === "administrator" ||
                              user.modulos?.Empresas?.editar
                                ? "pointer"
                                : "not-allowed",
                          }}
                          tooltip="Formas de Pagamento"
                          tooltipOptions={{ position: "top" }}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div
                className="grid"
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
                  gap: "15px",
                  alignItems: "stretch",
                }}
              >
                {empresasFiltrados.map((item, idx) => (
                  <div key={idx}>
                    <div
                      style={{
                        backgroundColor: "#ffffff",
                        border: "1px solid #e8e8e8",
                        borderRadius: "10px",
                        padding: "12px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        transition: "all 0.3s ease",
                        "&:hover": {
                          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                          transform: "translateY(-2px)",
                        },
                      }}
                    >
                      {/* Informações da Empresa */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          marginBottom: "5px",
                          paddingBottom: "5px",
                          borderBottom: "1px solid #e8e8e8",
                        }}
                      >
                        <div
                          style={{
                            background:
                              "linear-gradient(135deg, #B83732 0%, #D65A55 100%)",
                            borderRadius: "10px",
                            padding: "10px",
                            display: "inline-flex",
                          }}
                        >
                          <FaBuilding
                            style={{ fontSize: "1.5rem", color: "#fff" }}
                          />
                        </div>

                        <div style={{ flex: 1 }}>
                          <h3
                            style={{
                              fontSize: "1rem",
                              fontWeight: "600",
                              color: "#2c3e50",
                              margin: "0",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.nome}
                          </h3>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                              color: "#64748b",
                              fontSize: "0.85rem",
                            }}
                          >
                            <FaIdCard
                              style={{ fontSize: "0.7rem", color: "#64748b" }}
                            />
                            <span>{item.cnpj}</span>
                          </div>
                        </div>
                      </div>

                      {/* Detalhes da Empresa */}
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr",
                          gap: "6px",
                          marginBottom: "5px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            backgroundColor: "#f8f9fa",
                            border: "1px solid #e8e8e8",
                            padding: "6px",
                            borderRadius: "6px",
                            flexDirection: "column",
                            gap: "5px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <FaPhone
                              style={{
                                color: "#2980b9",
                                fontSize: "0.75rem",
                              }}
                            />
                            <span
                              style={{
                                fontSize: "0.8rem",
                                color: "#2c3e50",
                                fontWeight: "500",
                              }}
                            >
                              {item.telefone}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Cidade/Estado */}
                      <div
                        style={{
                          backgroundColor: "#f8f9fa",
                          border: "1px solid #e8e8e8",
                          padding: "6px",
                          borderRadius: "6px",
                          marginBottom: "6px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <FaMapMarkerAlt
                            style={{
                              color: "#e74c3c",
                              fontSize: "0.75rem",
                            }}
                          />
                          <span
                            style={{
                              fontSize: "0.85rem",
                              color: item.cidade ? "#2c3e50" : "#95a5a6",
                              fontWeight: "500",
                            }}
                          >
                            {item.cidade && item.estado
                              ? `${item.cidade} - ${item.estado}`
                              : item.cidade ||
                                item.estado ||
                                "Aguardando cadastro..."}
                          </span>
                        </div>
                      </div>

                      {/* Ações Secundárias */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          paddingTop: "5px",
                          gap: "5px",
                          marginTop: "auto",
                          borderTop: "1px solid #e8e8e8",
                        }}
                      >
                        {/* Ativo */}
                        <div
                          style={{
                            display: "flex",
                            gap: "5px",
                          }}
                        >
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              fontFamily: "'Rajdhani', sans-serif",
                              gap: "6px",
                              padding: "2px 6px",
                              borderRadius: "12px",
                              fontSize: "0.75rem",
                              fontWeight: "500",
                              color: item.ativo === "1" ? "#27ae60" : "#e74c3c",
                            }}
                          >
                            <div
                              style={{
                                width: "12px",
                                height: "12px",
                                borderRadius: "50%",
                                backgroundColor:
                                  item.ativo === "1" ? "#27ae60" : "#e74c3c",
                              }}
                            />
                          </div>
                          </div>

                          {/* Botões de ação */}
                        <div
                          style={{
                            display: "flex",
                            gap: "5px",
                          }}
                        >
                          <Button
                            icon="pi pi-file-edit"
                            onClick={() => {
                              if (
                                user.tipo === "administrator" ||
                                user.modulos?.Empresas?.editar
                              ) {
                                setEmpresaEditandoId(item.id);

                                // Preenche os campos do formulário
                                setNome(item.nome || "");
                                setCnpj(item.cnpj || "");
                                setEmail(item.email || "");
                                setTelefone(item.telefone || "");
                                setLogradouro(item.logradouro || "");
                                setNumero(item.numero || "");
                                setBairro(item.bairro || "");
                                setCidade(item.cidade || "");
                                setEstado(item.estado || "");
                                setCep(item.cep || "");
                                setAtivo(item.ativo === "1");
                                setVisibleEditarEmpresa(true);
                              }
                            }}
                            disabled={
                              !(
                                user.tipo === "administrator" ||
                                user.modulos?.Empresas?.editar
                              )
                            }
                            className="p-button-outlined p-button-sm"
                            style={{
                              outline: "none",
                              boxShadow: "none",
                              width: "25px",
                              height: "25px",
                              borderColor: "#dee2e6",
                              color: "#495057",
                              opacity:
                                user.tipo === "administrator" ||
                                user.modulos?.Empresas?.editar
                                  ? 1
                                  : 0.4,
                              cursor:
                                user.tipo === "administrator" ||
                                user.modulos?.Empresas?.editar
                                  ? "pointer"
                                  : "not-allowed",
                            }}
                            tooltip="Editar"
                            tooltipOptions={{ position: "top" }}
                          />

                          <Button
                            icon="pi pi-credit-card"
                            onClick={async () => {
                              if (
                                user.tipo === "administrator" ||
                                user.modulos?.Empresas?.editar
                              ) {
                                setEmpresaPagamentoEditandoId(item.id);
                                await buscarFormasPagamentoEmpresa(item.id);
                                setVisibleFormasPagamento(true);
                              }
                            }}
                            disabled={
                              !(
                                user.tipo === "administrator" ||
                                user.modulos?.Empresas?.editar
                              )
                            }
                            className="p-button-outlined p-button-sm"
                            style={{
                              outline: "none",
                              boxShadow: "none",
                              width: "25px",
                              height: "25px",
                              borderColor: "#dee2e6",
                              color: "#495057",
                              opacity:
                                user.tipo === "administrator" ||
                                user.modulos?.Empresas?.editar
                                  ? 1
                                  : 0.4,
                              cursor:
                                user.tipo === "administrator" ||
                                user.modulos?.Empresas?.editar
                                  ? "pointer"
                                  : "not-allowed",
                            }}
                            tooltip="Formas de Pagamento"
                            tooltipOptions={{ position: "top" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Loading Spinner */}
        {loading && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "200px",
            }}
          >
            <ProgressSpinner
              style={{ width: "50px", height: "50px" }}
              strokeWidth="8"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Empresas;
